import Service from './abstract';
import _ from 'lodash';

const defaultSmall = {
    tiny: true,
    pageSize: 100
};

class Issues extends Service {
    constructor () {
        super('issues');
    }

    getStatuses () {
        return this.get(`${this.basePath}/statuses`);
    }

    updateStatuses (data, issueId) {
        return this.put({
            url: `${this.basePath}/issues/${issueId}/toggle`,
            data,
        });
    }

    getReasons () {
        return this.get(`${this.basePath}/reasons`);
    }

    getTypes () {
        return this.get(`${this.basePath}/types`);
    }

    create (data = {}) {
        return this.post({
            url: `${this.basePath}/issues`,
            data
        });
    }

    getSmall (options = {}) {
        const opts = {
            url: `${this.basePath}/issues`,
            qs: _.defaultsDeep({}, options, defaultSmall)
        };

        return this.get(opts);
    }
}

export default new Issues();
